import { cBigNumber } from "./BigNumber";
import { iOptionResponse } from "../interfaces/chrInterfaces";
import { tDiscountPercent } from "../interfaces/interfaces";
import { fTokens, uTokens } from "../settings";
import { cStrike } from "./strike";


export class cChromiaOption {
	optId: string;
	fTokenCurrency: string;
	fTokenAddress: string;
	uTokenCurrency: string;
	uTokenAddress: string;
	optionType: boolean; // true => call, false => put
	optionTypeText: 'Put' | 'Call';
	strike: cStrike;
	maturityTime: number;
	maturityPrice: cBigNumber;

	constructor(responseOption: iOptionResponse, discountPercent: tDiscountPercent){
		this.optId = responseOption.id.toString('hex');

		this.fTokenAddress = responseOption.ft.toString('hex');
		this.uTokenAddress = responseOption.ut.toString('hex');

		// this.fTokenCurrency = fTokens[discountPercent].name;
		this.fTokenCurrency = 'fT';
		// this.uTokenCurrency = uTokens[discountPercent].name;
		this.uTokenCurrency = 'uT';

		this.optionType = Boolean(responseOption.is_call);
		this.optionTypeText = this.optionType? 'Call' : 'Put';

		this.strike = new cStrike(responseOption.strike_price);

		this.maturityTime = responseOption.mat_time;
		this.maturityPrice = new cBigNumber(responseOption.mat_price);
	}
}